import { IntlShape } from "react-intl";

const CANCEL_REQUEST_REASON_OPTIONS = (intl: IntlShape) => [
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionNotMeetRequirements",
      defaultMessage: "Request does not meet requirements",
    }),
    value: "not_meet_requirements",
  },
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionTooExpensive",
      defaultMessage: "Quotes are too expensive",
    }),
    value: "quotes_too_expensive",
  },
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionTooLate",
      defaultMessage: "There are no quotes in time",
    }),
    value: "no_quotes_in_time",
  },
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionShipmentNotNeeded",
      defaultMessage: "The shipment is no longer needed",
    }),
    value: "shipment_not_needed",
  },
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionAlternative",
      defaultMessage: "Shipment has been booked through an alternative source",
    }),
    value: "shipment_booked_alternative_source",
  },
  {
    label: intl.formatMessage({
      id: "tracking.cancelOptionOther",
      defaultMessage: "Other",
    }),
    value: "other",
  },
];

export default CANCEL_REQUEST_REASON_OPTIONS;
